{
  "name": "@skedulo/horizon-core",
  "version": "1.25.0",
  "description": "Horizon Core provides hosts with essential services and functionality to run the Horizon Framework",
  "type": "module",
  "main": "./src/index.ts",
  "types": "./src/index.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "pnpm build:lib",
    "build:lib": "pnpm check:deps && tsup",
    "build:types": "pnpm build:lib --dts-only",
    "check:deps": "node scripts/check-dependencies.js",
    "clean": "pnpm clean:cache && pnpm clean:deps && pnpm clean:output",
    "clean:cache": "rm -rf .cache && rm -rf .turbo && rm -rf node_modules/.cache",
    "clean:deps": "rm -rf node_modules",
    "clean:output": "rm -rf coverage && rm -rf dist",
    "dev": "pnpm dev:lib --tsconfig tsconfig.dev.json",
    "dev:lib": "pnpm build:lib --watch",
    "lint": "eslint \"**/*.ts*\"",
    "prepreview": "node scripts/preview-hint.js",
    "prepublishOnly": "json -I -f ./package.json -e 'this.main=\"./dist/index.js\"; this.types=\"./dist/index.d.ts\";'",
    "preview": "run-p dev:lib vite:preview",
    "test": "NODE_OPTIONS=--experimental-vm-modules jest",
    "test:coverage": "pnpm test --coverage",
    "test:preview": "node scripts/test-preview.js",
    "type-check": "tsc --noEmit",
    "upload:sourcemaps": "./scripts/upload-sourcemaps.sh",
    "vite:preview": "vite preview"
  },
  "devDependencies": {
    "@amplitude/analytics-browser": "0.4.1",
    "@apollo/client": "3.14.0",
    "@datadog/browser-rum": "4.6.1",
    "@datadog/datadog-ci": "2.16.0",
    "@golevelup/ts-jest": "0.4.0",
    "@jest/globals": "29.7.0",
    "@skedulo/breeze-ui": "1.26.1",
    "@skedulo/breeze-ui-react": "1.26.1",
    "@skedulo/eslint-config-horizon": "workspace:*",
    "@skedulo/horizon-common": "workspace:*",
    "@skedulo/horizon-toolkit": "workspace:*",
    "@skedulo/horizon-types": "workspace:*",
    "@skedulo/jest-config-horizon": "workspace:*",
    "@skedulo/protobuf-web": "0.1.260",
    "@skedulo/sked-ui": "21.8.1",
    "@skedulo/tsconfig-horizon": "workspace:*",
    "@skedulo/tsup-config-horizon": "workspace:*",
    "@testing-library/react": "13.4.0",
    "@types/lucene": "2.1.3",
    "@types/luxon": "3.4.2",
    "@types/moment-timezone": "0.5.12",
    "@types/nunjucks": "3.2.3",
    "@types/pluralize": "0.0.33",
    "@types/react": "18.3.1",
    "@types/react-dom": "18.3.1",
    "@vitejs/plugin-react": "4.7.0",
    "change-case": "4.1.2",
    "esbuild-plugin-external-global": "1.0.1",
    "esbuild-plugin-svgr": "2.1.0",
    "eslint": "8.45.0",
    "fake-indexeddb": "6.0.0",
    "graphql": "16.11.0",
    "html-react-parser": "4.2.0",
    "idb-keyval": "6.2.2",
    "jotai": "2.15.0",
    "jotai-optics": "0.3.1",
    "json": "11.0.0",
    "lodash": "4.18.1",
    "lucene": "2.1.1",
    "luxon": "3.5.0",
    "moment": "2.29.4",
    "moment-timezone": "0.5.35",
    "nanoid": "3.3.17",
    "npm-run-all": "4.1.5",
    "nunjucks": "3.2.4",
    "optics-ts": "2.4.1",
    "pluralize": "8.0.0",
    "query-string": "7.1.3",
    "react": "18.3.1",
    "react-async-hook": "4.0.0",
    "react-dom": "18.3.1",
    "react-error-boundary": "3.1.4",
    "shadow-dom-testing-library": "1.11.0",
    "subscriptions-transport-ws": "0.11.0",
    "ts-jest": "29.4.9",
    "tsup": "7.2.0",
    "typescript": "6.0.3",
    "vite": "6.4.3",
    "vite-plugin-environment": "1.1.3"
  },
  "publishConfig": {
    "access": "restricted"
  }
}
